import { IncidentPriority } from '@energybox/react-ui-library/dist/types';
import equals from 'ramda/src/equals';
import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setIncidentPriorityFilter } from '../actions/filters';
import { ApplicationState } from '../reducers';
import { redirectToIncidentPageEntry } from '../actions/incidents';

const useIncidentPriorityFilter = () => {
  const dispatch = useDispatch();

  const selectedIncidentPriorityFilters = useSelector<
    ApplicationState,
    IncidentPriority[]
  >(({ filters }) => {
    return filters.incidentPriorities;
  }, equals);

  const setFilter = useCallback(
    (newPriorities: IncidentPriority[]) => {
      dispatch(setIncidentPriorityFilter(newPriorities));
    },
    [dispatch]
  );

  const resetFilter = useCallback(() => {
    return dispatch(setIncidentPriorityFilter([]));
  }, [dispatch]);

  let redirectToIncidentPageEntries = useSelector(
    ({ incidents }: ApplicationState) => incidents.redirectToIncidentPageEntries
  );

  useEffect(() => {
    const displayedActiveFilter: any[] = [];
    if (Object.keys(redirectToIncidentPageEntries).length > 0) {
      displayedActiveFilter.push(
        redirectToIncidentPageEntries.entity.toUpperCase()
      );
    }
    if (displayedActiveFilter.length > 0) {
      selectedIncidentPriorityFilters.length = 0;
    } else if (displayedActiveFilter.length <= 0) {
      selectedIncidentPriorityFilters.length = 0;
    }
    setFilter(displayedActiveFilter);
  }, []);

  //TODO: the substract one logic at the end is b/c we have two
  //functionally duplicate incidentPriorities ('HIGHEST' + 'CRITICAL')
  //remove once Mike O cleans up BE
  const isIncidentPriorityFilterActive =
    selectedIncidentPriorityFilters.length > 0 &&
    selectedIncidentPriorityFilters.length <
      Object.keys(IncidentPriority).length - 1;

  return {
    setFilter,
    resetFilter,
    selectedIncidentPriorityFilters,
    isIncidentPriorityFilterActive,
  };
};

export default useIncidentPriorityFilter;
